export default function (context, {name, value, field}) {
    let col = context.state[name].columns.filter(i => {
        return i.name === field.replace('.Milliseconds', '');
    })[0];
    if (!col) return;
    col.width = value;
}